import React from 'react';
import { DebounceInput } from 'react-debounce-input';
import { useSpecificationContextUpdater } from './useSpecificationContextUpdater';
import { Col } from 'reactstrap';
import classNames from 'classnames';

export default function DebounceForText({ minLengthPRP, valuePRP, placeholderPRP, onChangeString, elementPRP, maxLengthPRP, sizePRP, readOnlyPRP, hideDisplayPRP, inputStyle }) {
    const specContextUpdater = useSpecificationContextUpdater();
    const readOnly = (readOnlyPRP === null || readOnlyPRP === undefined) ? false : !readOnlyPRP;
    return (
      <Col xs={sizePRP || "6"}>
        <DebounceInput
          className={classNames("form-control" ,{ "d-none": hideDisplayPRP})}
          minLength={minLengthPRP || 1}
          maxLength={maxLengthPRP || 99}
          style={inputStyle}
          value={valuePRP}
          debounceTimeout={350}
          onChange={event => specContextUpdater.onChange(onChangeString, event.target.value)}
          placeholder={placeholderPRP || ""}
          element={elementPRP || "input"}
          readOnly={readOnly}
          disabled={readOnly}
        />
      </Col>
    )
  }